const envFlag = process.env.NODE_ENV === 'production' ? 'master' : 'dev'
const IMG_SERVER_URL = `https://s3.ap-northeast-2.amazonaws.com/picture-${envFlag}.greenatm.kr/atmMaintenance/`

export { IMG_SERVER_URL }



// WEBPACK FOOTER //
// ./src/views/customerCare/index.js